import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { SYSTEM_INPUT } from './topics';

export const WAKE_BY_USER = 'SYSTEM/WAKE_BY_USER' as const;

export interface IWakeByUserAction {
  type: typeof WAKE_BY_USER;
  payload: {
    consoleId: string;
    timestamp: number;
  };
}

export const wakeByUserActionSchema = objectSchemaOf<IWakeByUserAction>({
  type: Joi.string().valid(WAKE_BY_USER).required(),
  payload: objectSchemaOf<IWakeByUserAction['payload']>({
    consoleId: Joi.string().required(),
    timestamp: Joi.number().required(),
  }).required(),
});

export const wakeByUser = actionCreator({
  type: WAKE_BY_USER,
  topic: SYSTEM_INPUT,
  schema: wakeByUserActionSchema,
});
